(function () {
  if (window.PairingUpsellDefined) return;
  window.PairingUpsellDefined = true;

  class PairingUpsell extends HTMLElement {
    constructor() {
      super();
      this.cards = this.querySelectorAll('[data-pairing-card]');
      this.cards.forEach(card => this.bindCard(card));
    }

    bindCard(card) {
      const variantBtns = card.querySelectorAll('.pairing-card__variant');
      const priceEl = card.querySelector('[data-pairing-price]');
      const addBtn = card.querySelector('[data-pairing-add]');

      const getActiveSource = () => {
        const activeBtn = card.querySelector('.pairing-card__variant.is-active');
        if (activeBtn) return activeBtn;
        return card.querySelector('input[data-variant-id]');
      };

      variantBtns.forEach(btn => {
        btn.addEventListener('click', () => {
          if (btn.disabled || btn.classList.contains('is-active')) return;
          variantBtns.forEach(b => {
            b.classList.remove('is-active');
            b.setAttribute('aria-checked', 'false');
          });
          btn.classList.add('is-active');
          btn.setAttribute('aria-checked', 'true');

          const cents = parseInt(btn.dataset.variantPrice, 10);
          if (!isNaN(cents) && priceEl) priceEl.textContent = this.formatMoney(cents);

          if (addBtn) {
            const available = btn.dataset.variantAvailable === 'true';
            addBtn.disabled = !available;
            addBtn.textContent = available
              ? (addBtn.dataset.labelDefault || '+ Add')
              : (addBtn.dataset.labelSoldout || 'Sold out');
          }
        });
      });

      if (addBtn) {
        addBtn.addEventListener('click', () => {
          if (addBtn.disabled) return;
          const src = getActiveSource();
          if (!src) return;
          const variantId = src.dataset.variantId || src.value;
          if (!variantId) return;
          this.addToCart(variantId, addBtn);
        });
      }
    }

    async addToCart(variantId, button) {
      button.disabled = true;
      button.classList.add('is-loading');

      const body = {
        items: [{ id: parseInt(variantId, 10), quantity: 1 }],
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: window.location.pathname
      };

      try {
        const url = (window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js';
        const response = await fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
          body: JSON.stringify(body)
        });
        const data = await response.json();
        if (!response.ok) throw new Error(data.description || data.message || 'Add to cart failed');
        this.onAddSuccess(button, data);
      } catch (err) {
        console.error('[PairingUpsell] add error:', err);
        this.onAddError(button);
      }
    }

    onAddSuccess(button, data) {
      this.updateCartSections(data.sections);
      button.classList.remove('is-loading');
      button.classList.add('is-added');
      button.textContent = button.dataset.labelAdded || 'Added ✓';
      setTimeout(() => {
        button.classList.remove('is-added');
        button.textContent = button.dataset.labelDefault || '+ Add';
        button.disabled = false;
      }, 1800);

      const drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.open === 'function') {
        try { drawer.open(); } catch (e) {}
      }

      if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
        try { window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'pairing-upsell', cartData: data }); } catch (e) {}
      }
    }

    onAddError(button) {
      button.classList.remove('is-loading');
      const orig = button.dataset.labelDefault || '+ Add';
      button.textContent = 'Error';
      setTimeout(() => {
        button.textContent = orig;
        button.disabled = false;
      }, 1800);
    }

    updateCartSections(sections) {
      if (!sections) return;
      const parser = new DOMParser();
      Object.keys(sections).forEach(id => {
        const html = sections[id];
        if (!html) return;
        const newDoc = parser.parseFromString(html, 'text/html');
        if (id === 'cart-drawer') {
          const drawer = document.querySelector('cart-drawer');
          if (drawer) {
            const newDrawer = newDoc.querySelector('cart-drawer');
            if (newDrawer) drawer.innerHTML = newDrawer.innerHTML;
            drawer.classList.remove('is-empty');
          }
        }
        if (id === 'cart-icon-bubble') {
          const bubble = document.getElementById('cart-icon-bubble');
          if (bubble) {
            const newBubble = newDoc.getElementById('shopify-section-cart-icon-bubble');
            if (newBubble) bubble.innerHTML = newBubble.innerHTML;
          }
        }
      });
    }

    formatMoney(cents) {
      if (window.Shopify && window.Shopify.formatMoney) {
        const fmt = (window.theme && window.theme.moneyFormat) || '${{amount}}';
        try { return window.Shopify.formatMoney(cents, fmt); } catch (e) {}
      }
      return '$' + (cents / 100).toFixed(2);
    }
  }

  if (!customElements.get('pairing-upsell')) {
    customElements.define('pairing-upsell', PairingUpsell);
  }
})();